@if (! hideLayout) {
  <header [ngClass]="{ 'logged-in-header': isAuthenticated }">
    <div class="logo-title-wrapper">
      <img src="../assets/images/lindskrog_logo.png" alt="Lindskrog logotyp" [routerLink]="['hem']" />
      <h1>
        @if (!isDriverMode) {
          <span>{{ !partner ? title : 'i samarbete med ' + partner.name }}</span>
          }@if (!isProd) {
<span [ngClass]="{
            description: true,
            dev: description === 'utvecklingsmiljö'
          }">{{ description }}
            @if (description === 'utvecklingsmiljö') {
              <mat-icon>build</mat-icon>
              }@if (description === 'staging') {
              <mat-icon
              >settings</mat-icon>
            }</span>
          }
        </h1>
      </div>
      @if (isAuthenticated) {
        <button class="signout" (click)="logout()">
          <mat-icon aria-label="Logga ut" fontIcon="person"></mat-icon>
          Logga ut {{user?.name || user?.username || ''}}
        </button>
      }
    </header>
    @if (isAuthenticated && !partner && !isDriverMode) {
      <app-navbar [isAdmin]="isAdmin"
      (openSearchDrawer)="openDriverSearch()" (openRegisterDrawer)="openRegisterDrawer()"></app-navbar>
    }
    @if (isAuthenticated && isDriverMode) {
      <div class="driver-action-bar">
        <span class="subtitle"><mat-icon aria-hidden="true">airport_shuttle</mat-icon> Chaufförläge</span>
        <div>
          <button mat-icon-button routerLink="/ny-bokning" (click)="closeDrawer()" aria-label="Ny bokning">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-icon-button (click)="openDriverSearch()" aria-label="Sök bland alla bokningar">
            <mat-icon>search</mat-icon>
          </button>
        </div>
      </div>
    }
    <mat-drawer-container mode="side" class="drawer-container" [hasBackdrop]="true">
      <mat-drawer class="drawer" #drawer [mode]="'over'" (openedStart)="drawerActive = true"
        (closedStart)="drawerActive = false" autoFocus="false">
        @if (isAuthenticated) {
          <div class="drawer-wrapper">
            <div class="search-drawer">
              <button mat-button class="close-side-search-btn" (click)="drawer.toggle()">
                <mat-icon fontIcon="close"></mat-icon>Stäng
              </button>
              @if (drawerContent === 'search') {
                <app-side-menu-search [drawerActive]="drawerActive"
                (closeDrawer)="drawer.close()"></app-side-menu-search>
              }
              @if (drawerContent === 'register') {
                <app-register [drawerActive]="drawerActive"></app-register>
              }
            </div>
            @if (!isDriverMode) {
              <app-side-menu (toggleDrawer)="drawer.toggle()" (closeDrawer)="drawer.close()"
              [drawerActive]="drawerActive"></app-side-menu>
            }
          </div>
        }
      </mat-drawer>
      <mat-drawer-content mode="side">
        <main>
          @if (isAuthenticated && !partner && !isDriverMode) {
            <app-side-menu (toggleDrawer)="drawer.toggle()"
            (closeDrawer)="drawer.close()" [drawerActive]="drawerActive"></app-side-menu>
          }
          <div class="wrapper">
            <router-outlet></router-outlet>
          </div>
        </main>
        <footer>
          <span>&#169; Rely IT - {{version}}</span>
        </footer>
      </mat-drawer-content>
    </mat-drawer-container>
    <app-order-info></app-order-info>
  }

  @if (hideLayout) {
    <div class="wrapper-no-layout">
      <router-outlet></router-outlet>
    </div>
  }